// extracted by mini-css-extract-plugin
export default {"title":"Register_title__EAiMb"};